import { findModuleExport } from '../webpack';
/** @component React Components */
export const FocusRing = findModuleExport((e) => e?.toString()?.includes('.GetShowDebugFocusRing())'));
